export const COMMITMENT_TYPES = [
  {
    id: "TASKLIST",
    src: require("@/assets/flaticons/checklist.svg"),
    text: "Finish all tasks on a list",
    disabled: false,
  },
  {
    id: "TIME_BASED_TASKLIST",
    src: require("@/assets/flaticons/time.svg"),
    text: "Spend certain amount of hours",
    disabled: false,
  },
  {
    id: "SEQUENCE",
    src: require("@/assets/flaticons/woman.svg"),
    text: "Follow a routine",
    disabled: false,
  },
  {
    id: "HABIT",
    src: require("@/assets/flaticons/meditation.svg"),
    text: "Develop a new habit",
    disabled: true,
  },
  {
    id: "AMOUNT",
    src: require("@/assets/flaticons/save.svg"),
    text: "Collect a certain amount of something",
    disabled: true,
  },
]
